import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert, Spin, Switch
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons'
import moment from 'moment';

const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Jiechu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.id = that.props.id
        fetch('/Contract/jiechu', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            if (that.props.jctime) {
                that.setState({
                    condition: {
                        jctime: that.props.jctime
                    }
                })
            }
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                },
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }


    render() {

        return (
            <>
                <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>{this.props.title}</a>
                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={400} visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="解除时间"
                                    // required={true}
                                >
                                    <DatePicker className="input" placeholder="请选择"
                                                onChange={this.onTimeChange.bind(this, 'jctime')}
                                                value={this.state.condition.jctime ? moment(this.state.condition.jctime) : null}
                                                style={{width: "100%"}}
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                </Modal>
            </>
        )
    }
}

export default Jiechu
